import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Loader from './Loader';
import { getUsername } from '../actions/auth';
import { selectAuthStatus } from '../selectors/auth';
import { STATUS_AUTH_FAILED, STATUS_AUTH_IDLE, STATUS_AUTH_LOADING } from '../reducers/auth';

const PrivateRoute = ({ element: Element, to }) => {
    const dispatch = useDispatch();
    const status = useSelector(selectAuthStatus);

    useEffect(() => {
        if (status === STATUS_AUTH_IDLE) {
            dispatch(getUsername());
        }
    }, [status]);

    if (status === STATUS_AUTH_LOADING || status === STATUS_AUTH_IDLE) {
        return <Loader />;
    }
    if (status === STATUS_AUTH_FAILED) {
        return <Navigate to={to}/>;
    }
    return <Element/>;
};

export default PrivateRoute;
